document.addEventListener('DOMContentLoaded', function() {
  const mobileSlides = document.querySelectorAll('.mobile-collection-image');
  const description = document.querySelector('.collabs-products__description');
  let swiper;

  // Function to handle mobile slides visibility and Swiper update
  const handleMobileSlides = () => {
    const isMobile = window.innerWidth <= 768;
    mobileSlides.forEach(slide => {
      if (isMobile) {
        slide.style.cssText = 'display: block; visibility: visible; width: auto; height: auto;';
      } else {
        slide.style.cssText = 'display: none !important; visibility: hidden; width: 0; height: 0;';
      }
    });

    // Actualizar Swiper después de cambiar la visibilidad
    if (swiper) {
      swiper.update();
    }
  };

  // Initial check BEFORE swiper initialization
  handleMobileSlides();

  // Add resize listener with debounce for better performance
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      handleMobileSlides();
    }, 250);
  });
  
  // Toggle description
  const title = document.querySelector('.collabs-products__title');
  if (title) {
    title.addEventListener('click', () => {
      requestAnimationFrame(() => {
        description.classList.toggle('active');
      });
    });
  }

  // Swiper initialization
  swiper = new Swiper('.collabs-products-swiper', {
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-progressbar',
      type: 'progressbar'
    },
    breakpoints: {
      320: {
        slidesPerView: 1.3,
        spaceBetween: 20
      },
      400: {
        slidesPerView: 2,
        spaceBetween: 15
      },
      500: {
        slidesPerView: 2.7,
        spaceBetween: 15
      },
      640: {
        slidesPerView: 3.2,
        spaceBetween: 15
      },
      769: {
        slidesPerView: 1.4,
        spaceBetween: 20
      },
      850: {
        slidesPerView: 1.7,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 2.3,
        spaceBetween: 20
      }
    }
  });

  // Dropdown functionality
  const handleDropdown = () => {
  // Get all title elements instead of just the first one
  const titles = document.querySelectorAll('.collabs-products__title');
  
  titles.forEach(title => {
    
    const container = title.closest('.collabs-products__container') || title.parentElement;
    
    const description = container.querySelector('.collabs-products__description');
    
    if (!description) return; 
    
    
    const newTitle = title.cloneNode(true);
    title.parentNode.replaceChild(newTitle, title);
    
    
    newTitle.addEventListener('click', function() {
      this.classList.toggle('active');
      description.classList.toggle('active');
    });
  });
};

  // Initial call
  handleDropdown();

  // Handle resize
  window.addEventListener('resize', handleDropdown);
});
